




























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetGroupsOfProject } from "@/request/groups";
@Component({})
export default class ProjectResearchListImportPatientChooseGroup extends Vue {
  @Prop()
  private projectId: any;
  @Prop()
  private visible: any;
  private groups: any[] = [];
  private groupId: any = "";
  private get ifVisible() {
    return this.visible;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 获得可选的分组列表
   */
  private fetchGroups() {
    GetGroupsOfProject(this, this.projectId).then((data: any) => {
      this.groups = data;
    });
  }
  /**
   * @description 保存
   */
  private save() {
    this.$emit("save", this.groupId);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchGroups();
  }
}
